import styled from 'styled-components';

export const Title = styled.h1`
  text-align: center;
  font-size: 25px;
  margin: 30px 0 0 0;
  color: #444444;
  margin: 15px;
`;
